<template>
  <div>
    <datalist id="nations-list">
      <option v-for="nation in nations.keys()"> {{ nation.toUpperCase() }}</option>
    </datalist>

    <b-tabs v-model="birthPlaceTab" pills card vertical @activate-tab="switchNationality">
      <b-tab id="italian-birth-place" title="Italiano">
        <b-card-text>
          <b-form-row>
            <b-form-group label="Luogo di nascita" class="col-md-6">
              <b-form-input
                autocomplete="off"
                id="it-birth-place-city"
                v-on:input="handleSearchInput"
                v-on:blur="validateBirthPlaceCity()"
                v-model="detail.birthPlaceTown"
                name="Luogo di nascita"
                :state="stateValidation('Luogo di nascita')"
                aria-describedby="input-birthplace-feedback"
              />

              <div style="position: relative">
                <div v-if="filteredList.length > 0 && isSearchActive" class="suggestions-list">
                  <div
                    v-for="(item, index) in filteredList"
                    :key="index"
                    class="suggestion-item"
                    @click="handleBirthPlaceSelection(item)"
                  >
                    {{ item.name }} - {{ item.provinceCode }}
                  </div>
                </div>
              </div>
              <b-form-invalid-feedback id="input-birthplace-feedback">
                {{ veeErrors.first('Luogo di nascita') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Provincia di nascita" class="col-md-6">
              <b-form-input
                readonly
                v-model="detail.birthPlaceProvince"
                name="Provincia di Nascita"
                :state="stateValidation('Provincia di Nascita')"
                aria-describedby="input-birthplace-feedback"
              />
              <b-form-invalid-feedback id="input-birthplace-feedback">
                {{ veeErrors.first('Provincia di Nascita') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>
        </b-card-text>
      </b-tab>
      <b-tab id="foreign-birth-place" title="Straniero">
        <b-card-text>
          <b-form-row>
            <b-form-group label="Nazione di nascita" class="col-md-6">
              <b-form-input
                autocomplete="off"
                id="birth-place-nation"
                list="nations-list"
                v-model="detail.birthPlaceNation"
                name="Nazione di nascita"
                v-validate="validateNation()"
                v-on:change="save"
                :state="stateValidation('Nazione di nascita')"
                aria-describedby="input-birthplace-nation-feedback"

                v-if="birthPlaceTab === FOREIGN_BIRTH_DATE_TAB"/>
              <b-form-invalid-feedback id="input-birthplace-nation-feedback">
                {{ veeErrors.first('Nazione di nascita') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Città di nascita" class="col-md-6">
              <b-form-input
                autocomplete="off"
                id="ee-birth-place-city"
                v-model="detail.birthPlaceTown"
                name="Città di nascita"
                v-on:change="save"
                :state="stateValidation('Città di nascita')"
                aria-describedby="input-birthplace-city-feedback"
                v-if="birthPlaceTab === FOREIGN_BIRTH_DATE_TAB"/>
              <b-form-invalid-feedback id="input-birthplace-city-feedback">
                {{ veeErrors.first('Città di nascita') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </div>

</template>

<script>
import TownsApi from "@/api/TownsApi";
import NationsApi from "@/api/NationsApi";

export default {
  name: 'BirthPlaceSelect',
  props: {
    value: {},
    eventName: {}
  },
  inject: ["parentValidator"],
  data: () => ({
    isSearchActive: false,
    search: '',
    selected: null,
    towns: [],
    nations: [],
    birthPlaceTab: 0,
    ITALIAN_BIRTH_DATE_TAB: 0,
    FOREIGN_BIRTH_DATE_TAB: 1,
    detail: {
      birthPlaceNation: 'ITALIA',
      birthPlaceTown: null,
      birthPlaceProvince: null
    }
  }),
  created() {
    this.initTownsAndNations()
    this.detail.birthPlaceNation = (this.value.birthPlaceNation != null) ? this.value.birthPlaceNation.toUpperCase() : 'ITALIA'
    this.detail.birthPlaceTown = this.value.birthPlaceTown
    this.detail.birthPlaceProvince = this.value.birthPlaceProvince
    this.birthPlaceTab = (this.detail.birthPlaceNation === 'ITALIA') ? this.ITALIAN_BIRTH_DATE_TAB : this.FOREIGN_BIRTH_DATE_TAB
    this.$nextTick(() => {
      this.$validator = this.parentValidator;
    });
  },
  computed: {
    filteredList() {
      return this.towns.filter(item => {
        const search = this.search.toLowerCase()
        return (
          item.name.toLowerCase().includes(search)
        )
      })
    }
  },
  methods: {
    initTownsAndNations() {
      TownsApi.all().then((result) => {
        this.towns = result
      })

      NationsApi.all().then((result) => {
        this.nations = new Map(result.map((nation) => [nation.name, nation.codeIsoAlpha3]))
        this.nations.set("Italia", "ITA")
      })
    },
    reset() {
      this.selected = null
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) return !this.veeErrors.has(ref)
      else return null
    },
    handleSearchInput(value) {
      this.search = value
      console.log("Ora search è: " + this.search)
      this.isSearchActive = true
    },
    handleBirthPlaceSelection(value) {
      this.detail.birthPlaceTown = value.name;
      this.fillBirthPlaceProvince(value.provinceCode);
      this.isSearchActive = false
    },
    fillBirthPlaceProvince(provinceCode) {
      this.detail.birthPlaceProvince = provinceCode
      this.save()
    },
    validateNation() {
      let validNations = Array.from(this.nations.keys())
      let validNationsRegex = validNations.map(nation => nation.toUpperCase()).join('|')
      return {required: true, regex: validNationsRegex}
    },
    validateTown() {
      let validTowns = this.towns.map(town => town.name.toUpperCase());
      let validTownsRegex = validTowns.join('|');
      if (this.detail.birthPlaceNation === 'ITALIA') {
        return {required: true, regex: validTownsRegex}
      } else {
        return {required: false}
      }
    },
    validateBirthPlaceCity() {
      if (!this.towns.find(town => town.name === this.detail.birthPlaceTown)) {
        this.detail.birthPlaceTown = ''
      }
    },
    switchNationality(newIndex) {
      switch (newIndex) {
        case this.ITALIAN_BIRTH_DATE_TAB:
          this.detail.birthPlaceTown = null
          this.detail.birthPlaceProvince = null
          this.detail.birthPlaceNation = 'ITALIA'
          break;
        case this.FOREIGN_BIRTH_DATE_TAB:
          this.detail.birthPlaceTown = null
          this.detail.birthPlaceProvince = 'EE'
          this.detail.birthPlaceNation = null
          break;
      }
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit(this.eventName, this.detail)
        }
      })
    }
  }
}
</script>

<style>
.suggestions-list {
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 50;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
  background: white;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
}
</style>
